import React from 'react';
import Loadable from 'react-loadable';
import { useParams } from 'react-router';
import sortBy from 'lodash/sortBy';
import LoadableLoading from 'components/LoadableLoading';
import { ILoadedProps, IPageProps, IProps } from './interfaces';
import { getAreaList, getPositions, getServiceOrgHeads, getServiceOrgList } from './api';

export const path = '/service-org/area-list/:serviceOrgGuid?';
export const getPath = (guid?: string) =>
  guid ? `/service-org/area-list/${guid}` : '/service-org/area-list';

const empty = <T,>() => Promise.resolve([] as T[]);

const PageAreaList: React.FC<IProps> = (props) => {
  const { serviceOrgGuid } = useParams<{ serviceOrgGuid?: string }>();

  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import('./page'),
      serviceOrgList: getServiceOrgList,
      positions: getPositions,
      areaList: serviceOrgGuid ? () => getAreaList(serviceOrgGuid) : empty,
      orgHeads: serviceOrgGuid ? () => getServiceOrgHeads(serviceOrgGuid) : empty,
    },
    loading: LoadableLoading,
    render(loaded: ILoadedProps, loadedProps: {}) {
      const Page = loaded.page.default;

      return (
        <Page
          {...(loadedProps as IPageProps)}
          {...props}
          serviceOrgList={sortBy(loaded.serviceOrgList, 'currentName')}
          positions={sortBy(
            (loaded.positions || []).map((position) => ({
              value: position.positionId,
              label: position.positionName,
            })),
            'label',
          )}
          initialAreaList={loaded.areaList || []}
          initialOrgHeads={loaded.orgHeads || []}
        />
      );
    },
  });

  return <LoadableMap key={serviceOrgGuid || 'all'} {...props} />;
};

export default PageAreaList;
